import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPDept";

const ADPDeptService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(facilityCode: string, departmentCode: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${facilityCode}/${departmentCode}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(facilityCode: string, departmentCode: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${facilityCode}/${departmentCode}`, item);
    return response.data;
  },

  async delete(facilityCode: string, departmentCode: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${facilityCode}/${departmentCode}`);
    return response.data;
  },

  async getDropdown(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown`);
    return response.data;
  },
};

export default ADPDeptService;